import { render, staticRenderFns } from "./SurfOverviewScrollContainer.vue?vue&type=template&id=5077dd63&scoped=true"
import script from "./SurfOverviewScrollContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./SurfOverviewScrollContainer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SurfOverviewScrollContainer.vue?vue&type=style&index=0&id=5077dd63&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5077dd63",
  null
  
)

export default component.exports